var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96013(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-013-1,.cls-96-013-2,.cls-96-013-4,.cls-96-013-5{fill:#fff;}.cls-96-013-2{stroke:#6e6f70;}.cls-96-013-2,.cls-96-013-4,.cls-96-013-5{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-96-013-3{fill:#6f6e6f;}.cls-96-013-4,.cls-96-013-5{stroke:#6f6e6f;}.cls-96-013-4{fill-rule:evenodd;}.cls-96-013-6{fill:none;opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-013-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-013-2",
    x: 23.05,
    y: 17.88,
    width: 62.99,
    height: 28.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-013-2",
    x: 17.78,
    y: 23.04,
    width: 62.99,
    height: 28.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-3",
    d: "M56.85,40.31H51.37a.66.66,0,0,1-.66-.67.65.65,0,0,1,.66-.64H54V30.83l-2.64,1.8a.64.64,0,0,1-.91-.18.65.65,0,0,1,.19-.91l3.62-2.46a.81.81,0,0,1,.43-.14.7.7,0,0,1,.69.68V39h1.51a.65.65,0,0,1,.66.64A.66.66,0,0,1,56.85,40.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-3",
    d: "M62.72,40.44c-2.47,0-3.56-1.88-3.56-4V33c0-2.17,1.09-4.05,3.56-4.05s3.56,1.88,3.56,4.05v3.4C66.28,38.56,65.18,40.44,62.72,40.44ZM64.89,33c0-1.68-.72-2.78-2.17-2.78s-2.17,1.1-2.17,2.78v3.39c0,1.68.7,2.78,2.17,2.78s2.17-1.1,2.17-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-3",
    d: "M71.34,40.44c-2.46,0-3.56-1.88-3.56-4V33c0-2.17,1.1-4.05,3.56-4.05S74.9,30.82,74.9,33v3.4C74.9,38.56,73.8,40.44,71.34,40.44ZM73.51,33c0-1.68-.72-2.78-2.17-2.78s-2.17,1.1-2.17,2.78v3.39c0,1.68.71,2.78,2.17,2.78s2.17-1.1,2.17-2.78Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-013-2",
    x1: 33.01,
    y1: 23.04,
    x2: 33.01,
    y2: 51.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M10,43.66v26.2c0,2,6.61,3.55,14.76,3.55s14.76-1.59,14.76-3.55V43.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M39.49,65.05c0,1.62-6.61,2.94-14.76,2.94S10,66.67,10,65.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M39.49,54.2c0,1.62-6.61,2.94-14.76,2.94S10,55.82,10,54.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M39.49,59.62c0,1.63-6.61,2.94-14.76,2.94S10,61.25,10,59.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M39.49,48.77c0,1.62-6.61,2.94-14.76,2.94S10,50.39,10,48.77"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-96-013-5",
    cx: 24.73,
    cy: 43.35,
    rx: 14.76,
    ry: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M48,64.34V74.57c0,2,6.61,3.55,14.76,3.55s14.75-1.59,14.75-3.55V64.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-013-4",
    d: "M77.47,69.45c0,1.63-6.6,2.94-14.75,2.94S48,71.08,48,69.45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-96-013-5",
    cx: 62.72,
    cy: 64.03,
    rx: 14.76,
    ry: 2.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-013-6",
    width: 96,
    height: 96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96013);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_013.ef5b3a8d95e0516306290a23cf7eb80d.svg";
export { ForwardRef as ReactComponent };